import React, { useRef } from 'react'
import playNowButtonBg from '@assets/button-playnow.svg'
import { useTranslation } from '@amusnet/translations/react'
import { useShrinkTextToFit } from '@amusnet/react-ui'

interface PlayNowButtonProps {
    onClick: () => void
    id?: string
}

const PlayNowButton: React.FC<PlayNowButtonProps> = ({ onClick, id }) => {
    const { t } = useTranslation()
    const playNowButtonRef = useRef<HTMLSpanElement>(null)
    const label = t('gameui.playNow')

    useShrinkTextToFit({
        refresh: [label],
        designFontSize: 30,
        bounds: { width: 240 },
        textRef: playNowButtonRef,
    })

    return (
        <button id={id} className="relative w-[276px] h-[88px]" onClick={onClick}>
            <img
                src={playNowButtonBg}
                alt="Play now button background"
                className="absolute inset-0 w-full h-full object-cover"
                draggable="false"
            />

            <span
                ref={playNowButtonRef}
                className="relative text-white font-bold text-[30px] leading-[38px] z-10 uppercase drop-shadow-text"
            >
                {label}
            </span>
        </button>
    )
}

export default PlayNowButton
